/**
 * 账号管理「登录记录」的展示辅助：UA → 简短设备标签、会话结束原因 → 中文。
 * 原始值（完整 UA / 原因码）仍由调用方放在悬停提示里，这里只做压缩，不做判定。
 */

/** User-Agent → 「企业微信 · iOS」「Chrome · macOS」；认不出就截断原串。 */
export function describeUserAgent(ua: string | null | undefined): string {
  if (!ua) return '-';
  const app = /wxwork/i.test(ua) ? '企业微信' : /MicroMessenger/i.test(ua) ? '微信' : null;
  // Edge / Chrome(iOS 为 CriOS) 的 UA 里都带 Safari，须先判；Chrome UA 里也有 Safari/
  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /Firefox\//.test(ua)
      ? 'Firefox'
      : /Chrome\/|CriOS/.test(ua)
        ? 'Chrome'
        : /Safari\//.test(ua)
          ? 'Safari'
          : null;
  // iOS UA 含 "like Mac OS X"、Android UA 含 "Linux"：移动端必须先于桌面端判断
  const os = /iPhone|iPad|iPod/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /Mac OS X|Macintosh/.test(ua)
        ? 'macOS'
        : /Windows/.test(ua)
          ? 'Windows'
          : /Linux/.test(ua)
            ? 'Linux'
            : null;
  const parts = [app ?? browser, os].filter((p): p is string => !!p);
  return parts.length > 0 ? parts.join(' · ') : ua.slice(0, 40);
}

/** 会话结束原因码 → 中文；超管踢出时手填的理由等未知值原样返回。 */
export function revokeReasonLabel(reason: string | null | undefined): string {
  if (!reason) return '-';
  if (reason === 'user_logout') return '主动退出';
  if (reason === 'user_disabled') return '账号已停用';
  if (reason === 'user_not_found') return '账号不存在';
  if (reason === 'force_revoke_by_admin') return '被超管强制踢出';
  if (reason.startsWith('admin_disabled_by_')) return '被超管停用';
  return reason;
}
